/* Shopify Google Maps 
 * Pattern matches the attached file:
 * - initializeGoogleMapsTrigger(rootEl=document, isDesignModeEvent=false)
 * - Runs on DOMContentLoaded and shopify:section:load
 * Usage:
 *   <div class="google-map__inner" data-map-var="MyMapDataVar"></div>
 *   <script>
 *     window.MyMapDataVar = {
 *       api_key: 'YOUR_API_KEY',
 *       zoom: 10,
 *       lat: 40.7128,
 *       lng: -74.0060,
 *       styles: [],
 *       locations: [
 *         { lat: 40.7128, lng: -74.0060, title: 'NYC', slug: 'nyc', url: 'https://domain.com/url/' }
 *       ],
 *       marker: 'marker.png'
 *     };
 *   </script>
 */

(function () {
  // Keep a tiny state to avoid re-initializing the same element
  const STATE = {
    apiLoaded: false,
    loading: false,
    maps: [],
  };

  // Load the Google Maps JS API once, using the first map element's api_key
  function loadGoogleMapsApiOnce(data) {
    if (STATE.apiLoaded || STATE.loading) return;
    STATE.loading = true;

    const script = document.createElement('script');
    script.type = 'text/javascript';
    // v=quarterly is Google's current stable; using callback=initMaps
    const params = new URLSearchParams({
      v: 'quarterly',
      key: data.api_key,
      callback: 'initMaps'
    });
    script.src = 'https://maps.googleapis.com/maps/api/js?' + params.toString();
    script.async = true;
    script.defer = true;
    script.onerror = function () {
      console.error('[Google Maps] Failed to load API script.');
      STATE.loading = false;
    };
    document.body.appendChild(script);
  }

  // Global callback for Google Maps API (required by &callback=initMaps)
  window.initMaps = function () {
    // Find any map elements that haven't been initialized yet
    const elements = document.querySelectorAll('.google-map__inner:not([data-gmap-ready="true"])');
    elements.forEach(function (el) {
      try {
        makeGoogleMap(el);
      } catch (e) {
        console.error('[Google Maps] Initialization error:', e);
      }
    });
    STATE.apiLoaded = true;
    STATE.loading = false;
  };

  function makeGoogleMap(el) {
    const mapVar = el.getAttribute('data-map-var');
    if (!mapVar || !window.map_data[mapVar]) {
      throw new Error('Missing or invalid data-map-var for Google Map element.');
    }
    const data = window.map_data[mapVar];

    // Bounds for all markers
    const bounds = new google.maps.LatLngBounds();
  
    // parse
    data.styles = JSON.parse(data.styles);

    // Map options (vanilla JS)
    const mapOptions = {
      scrollwheel: false,
      navigationControl: false,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      draggable: true,
      disableDefaultUI: false,
      zoom: Number(data.zoom) || 8,
      center: new google.maps.LatLng(Number(data.lat) || 0, Number(data.lng) || 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: (data.styles && typeof data.styles === "object") ? data.styles : undefined
    };

    const map = new google.maps.Map(el, mapOptions);

    // Retina-aware marker image
    const dpr = (window.devicePixelRatio === undefined ? 1 : window.devicePixelRatio);
    const requireImageSuffix = dpr > 1 ? '@2x' : '';
    const markerUrl = data.marker.replace(/(\.[^.]+)$/, `${requireImageSuffix}$1`);

    const markers = [];
    
    // parse
    data.locations = JSON.parse(data.locations);
    
    if (data.locations && typeof data.locations === 'object') {
      
      console.log('loop locations');
      Object.keys(data.locations).forEach(function (key) {
        const loc = data.locations[key];
        const lat = Number(loc.lat);
        const lng = Number(loc.lng);
        
        if (Number.isNaN(lat) || Number.isNaN(lng)) return;

        const latlng = new google.maps.LatLng(lat, lng);
        
        console.log(lat + ',' + lng);

        const marker = new google.maps.Marker({
          position: latlng,
          map: map,
          icon: {
            url: markerUrl,
            // size 22x30 to match original code
            scaledSize: new google.maps.Size(22, 30)
          },
          title: String(loc.title || '')
        });

        if (loc.url && String(loc.url).trim() !== '') {
          marker.url = loc.url;
        
          marker.addListener('click', function () {
            window.open(marker.url, '_blank');
          });
        }

        markers.push(marker);
        bounds.extend(latlng);
      });
    }

    // Fit to markers
    if (markers.length > 1) {
      map.fitBounds(bounds, {
          top: Number(data.padding) || 50,
          right: Number(data.padding) || 50,
          bottom: Number(data.padding) || 50,
          left: Number(data.padding) || 50
      });
    }

    // mark as initialized
    el.setAttribute('data-gmap-ready', 'true');

    // keep references similar to original
    STATE.maps.push(map);
  }

  // Entry point: find maps in a root element, and ensure API script is present
  function initializeGoogleMapsTrigger(rootEl = document, isDesignModeEvent = false) {
    const mapEls = rootEl.querySelectorAll('.google-map__inner');

    if (!mapEls.length) return;

    // Load API using the first map's data
    const first = mapEls[0];
    const mapVar = first.getAttribute('data-map-var');
    if (!mapVar || !window.map_data[mapVar] || !window.map_data[mapVar].api_key) {
      console.warn('[Google Maps] Skipping load: missing data-map-var or api_key.');
      return;
    }
    loadGoogleMapsApiOnce(window.map_data[mapVar]);

    // If API already loaded (e.g., switching sections in editor), build immediately
    if (window.google && window.google.maps && typeof window.initMaps === 'function') {
      window.initMaps();
    }
  }

  // Public triggers (match attached file behavior)
  window.addEventListener('DOMContentLoaded', function () {
    initializeGoogleMapsTrigger();
  });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initializeGoogleMapsTrigger(event.target, true);
    });
  }

  // Expose initializer if needed elsewhere
  window.initializeGoogleMapsTrigger = initializeGoogleMapsTrigger;
})();
